import { useState } from "react";
import Reveal from "@/pages/home/components/Reveal";
import SectionTitle from "@/pages/home/components/SectionTitle";
import { addresses } from "@/mocks/home";

export default function AddressEntries() {
  const [toast, setToast] = useState("");
  const [copied, setCopied] = useState<string | null>(null);

  const handleCopy = async (name: string, code: string) => {
    try {
      await navigator.clipboard.writeText(`金桔影院 ${name}（${code}）`);
    } catch {
      // 静态展示：剪贴板不可用时也给出同样的反馈
    }
    setCopied(name);
    setToast(`已复制「${name}」入口指引，请对照本页名称进入`);
    window.setTimeout(() => setToast(""), 2600);
    window.setTimeout(() => setCopied(null), 2600);
  };

  return (
    <section id="address" className="bg-background-100/70 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <Reveal>
          <SectionTitle
            kicker="最新地址与入口速览"
            title="四条入口，按状态挑一条就能走"
            desc="状态与更新时间会随维护情况调整。日常优先看“主站入口”，高峰挤不动就换“备用线路”，手机用户直接走“移动端入口”。"
          />
        </Reveal>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2">
          {addresses.map((item, index) => (
            <Reveal key={item.name} delay={index * 80}>
              <article className="flex h-full flex-col rounded-xl border border-background-200/80 bg-background-50 p-6 transition-colors hover:border-primary-300">
                <div className="flex items-start justify-between gap-3">
                  <div>
                    <h3 className="font-heading text-lg font-bold text-foreground-950">{item.name}</h3>
                    <p className="mt-1 text-xs tracking-wide text-foreground-500">{item.code}</p>
                  </div>
                  <span
                    className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-3 py-1 text-xs font-medium ${
                      item.tone === "ok"
                        ? "bg-accent-100 text-accent-800"
                        : "bg-primary-100 text-primary-800"
                    }`}
                  >
                    <span
                      className={`h-2 w-2 rounded-full ${
                        item.tone === "ok" ? "bg-accent-500" : "bg-primary-500"
                      }`}
                    ></span>
                    {item.status}
                  </span>
                </div>

                <p className="mt-4 flex-1 text-sm leading-relaxed text-foreground-600">{item.desc}</p>

                <div className="mt-5 flex flex-wrap items-center gap-x-5 gap-y-2 text-xs text-foreground-500">
                  <span className="inline-flex items-center gap-1.5">
                    <i className="ri-speed-up-line text-sm" aria-hidden="true"></i>
                    {item.load}
                  </span>
                  <span className="inline-flex items-center gap-1.5">
                    <i className="ri-refresh-line text-sm" aria-hidden="true"></i>
                    更新于 {item.updated}
                  </span>
                </div>

                <button
                  type="button"
                  onClick={() => handleCopy(item.name, item.code)}
                  className="mt-5 inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 sm:w-auto"
                >
                  <i className={copied === item.name ? "ri-check-line text-base" : "ri-file-copy-line text-base"} aria-hidden="true"></i>
                  {copied === item.name ? "已复制指引" : "复制入口指引"}
                </button>
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal>
          <p className="mt-8 flex items-start gap-2 rounded-lg border border-secondary-200 bg-secondary-50 px-4 py-3 text-xs leading-relaxed text-secondary-900 md:text-sm">
            <i className="ri-information-line mt-0.5 text-base" aria-hidden="true"></i>
            本页仅提供入口信息的核对与整理，所有按钮为静态展示，不会跳转到任何外部页面，也不会收集你的任何信息。
          </p>
        </Reveal>
      </div>

      {toast ? (
        <div className="fixed bottom-6 left-1/2 z-50 -translate-x-1/2 rounded-lg border border-background-300/70 bg-foreground-950 px-5 py-3 text-sm text-background-50">
          <span className="inline-flex items-center gap-2">
            <i className="ri-checkbox-circle-line text-base text-primary-300" aria-hidden="true"></i>
            {toast}
          </span>
        </div>
      ) : null}
    </section>
  );
}